import AppraiserDataMapper from '../mappers/AppraiserDataMapper';
import { orderBy } from 'lodash';
import GET_APPRAISER_SELECTION_LIST from '../queries/getAppraiserSelectionList';
import { useQuery } from '@apollo/client';

export const useSelectionListOptions = systemRoleId => {
  const {
    data: selectionListData,
    loading: selectionLisLoading,
    error: selectionListError
  } = useQuery(GET_APPRAISER_SELECTION_LIST, {
    variables: {
      systemRoleId: systemRoleId
    },
    skip: !systemRoleId
  });

  const desiredRoleOptions = selectionListData
    ? AppraiserDataMapper.dataToDropDownList(
        selectionListData.appraiserSelectionList.DesiredRoleOptions
      )
    : [];
  const currentRoleOptions = selectionListData
    ? AppraiserDataMapper.currentRoleToDropDownList(
        selectionListData.appraiserSelectionList.CurrentRoleOptions
      )
    : [];
  const timeZoneOptions = selectionListData
    ? orderBy(
        AppraiserDataMapper.dataToDropDownList(
          selectionListData.appraiserSelectionList.TimeZoneOptions
        )
      )
    : [];
  const directChannelOptions = selectionListData
    ? AppraiserDataMapper.dataToDropDownList(
        selectionListData.appraiserSelectionList.DirectChannelOptions
      )
    : [];

  const observationOptions = selectionListData
    ? AppraiserDataMapper.dataToDropDownList(
        selectionListData.appraiserSelectionList.ObservationOptions
      )
    : [];

  return {
    desiredRoleOptions,
    currentRoleOptions,
    timeZoneOptions,
    selectionLisLoading,
    selectionListError,
    directChannelOptions,
    observationOptions
  };
};
